import DeleteIcon from 'assets/icons/deleteIcon.svg';
import FailureIcon from 'assets/icons/failureIcon.svg';
import SuccessIcon from 'assets/icons/successIcon.svg';
import { bulkUploadDataValidationInterfaceInstance } from 'Interfaces/JobsInterface/index';
import { Button } from 'primereact/button';
import classes from './DataValidationComponent.module.scss';
import useDataValidationComponent from './useDataValidatonComponent';

import { observer } from 'mobx-react';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { formatDateForDisplay } from 'utils/dateUtilities';

const DataValidationComponent = ({
  data,
  successCallBack,
  goBack
}: {
  data: bulkUploadDataValidationInterfaceInstance[];
  successCallBack: () => void;
  goBack: () => void;
}) => {
  const {
    bulkUpdateData,
    view,
    isBulkUpdating,
    checkIfThereAreErrors,
    handleVerify,
    handleRowDeleteButtonClick,
    getErrorDescription,
    isAnimationRunning,
    bulkUpdateResponse,
    getMaxWidthForProgressBar,
    priorityOptions,
    statusOptions,
    runTypeOptions,
    inputOperations,
    checkIfVerifyDataButtonIsDiabled,
    roomOptions
  } = useDataValidationComponent({ data, successCallBack });

  return (
    <div className={classes.DataValidationComponentcontainer}>
      {!isAnimationRunning ? (
        <>
          <div className={classes.tableWrapper}>
            <table className={classes.dataTable} style={{ maxHeight: '60vh !important' }}>
              <thead>
                <tr>
                  <th>Job ID</th>
                  <th>Priority</th>
                  <th>Status</th>
                  <th>Room</th>
                  <th>NDC</th>
                  <th>Description</th>
                  <th>Qty Containers</th>
                  <th>Qty Per Container</th>
                  <th>Run Type</th>
                  <th>Qty Units</th>
                  <th>Confirmed Date</th>
                  <th>Initial Note</th>
                  <th>Bottles at Start</th>
                  <th>Job Start Time</th>
                  {checkIfThereAreErrors() && <th className={classes.errorsTh}>Job Details</th>}
                  {checkIfThereAreErrors() && <th className={classes.resolveErrors}>Errors</th>}
                </tr>
              </thead>
              <tbody className="bulkUpdateTable" style={{ maxHeight: '60vh !important' }}>
                {view === 'view' ? (
                  <>
                    {bulkUpdateData.map((data, index) => {
                      return (
                        <tr
                          key={`${data.jobId}-${data.priority}-${data.status}-${data.room}-${data.ndc}-${data.description}-${data.qtyOfContainersToFill}-${data.qtyPerContainer}-${data.runType}-${data.qtyUnitsToPackage}-${data.confirmedDate}-${data.initialNote}-${data.numberOfBottlesAtShiftStart}-${data.jobStartTime}`}
                        >
                          <td>{data.jobId}</td>
                          <td>{data.priority}</td>
                          <td>{data.status}</td>
                          <td>{data.room}</td>
                          <td>{data.ndc}</td>
                          <td>{data.description}</td>
                          <td>{data.qtyOfContainersToFill}</td>
                          <td>{data.qtyPerContainer}</td>
                          <td>{data.runType}</td>
                          <td>{data.qtyUnitsToPackage}</td>
                          <td style={{ minWidth: '10rem' }}>{data.confirmedDate}</td>
                          <td>{data.initialNote}</td>
                          <td>{data.numberOfBottlesAtShiftStart}</td>
                          <td>
                            {data.jobStartTime
                              ? formatDateForDisplay(new Date(data.jobStartTime), true)
                              : '-'}
                          </td>
                        </tr>
                      );
                    })}
                  </>
                ) : (
                  <>
                    {bulkUpdateData.map((data, index) => {
                      return (
                        <tr
                          key={`${data.jobId}-${data.priority}-${data.status}-${data.room}-${data.ndc}-${data.description}-${data.qtyOfContainersToFill}-${data.qtyPerContainer}-${data.runType}-${data.qtyUnitsToPackage}-${data.confirmedDate}-${data.initialNote}-${data.numberOfBottlesAtShiftStart}-${data.jobStartTime}`}
                        >
                          <td>
                            <InputText
                              required
                              value={inputOperations.jobId.value(index)}
                              onChange={e => inputOperations.jobId.onChange(index, e.target.value)}
                            />
                          </td>
                          <td>
                            <Dropdown
                              value={inputOperations.priority.value(index)}
                              onChange={e => {
                                inputOperations.priority.onChange(index, e.target.value.code);
                              }}
                              options={priorityOptions}
                              optionLabel="name"
                              placeholder="Select Priority"
                              style={{
                                width: '9rem',
                                maxWidth: '5rem',
                                padding: '0.0rem 0.5rem'
                              }}
                            />
                          </td>
                          <td>
                            <Dropdown
                              value={inputOperations.status.value(index)}
                              showClear
                              onChange={e => {
                                inputOperations.status.onChange(
                                  index,
                                  e.target.value ? e.target.value.code : e.target.value
                                );
                              }}
                              options={statusOptions}
                              optionLabel="name"
                              placeholder="Select Status"
                              style={{
                                width: '9rem',
                                maxWidth: '9rem',
                                padding: '0.0rem 0.5rem'
                              }}
                            />
                          </td>
                          <td>
                            <Dropdown
                              value={inputOperations.room.value(index)}
                              onChange={e => {
                                inputOperations.room.onChange(index, e.target.value.code);
                              }}
                              options={roomOptions}
                              optionLabel="name"
                              placeholder="Select Room"
                              style={{
                                width: '9rem',
                                maxWidth: '9rem',
                                padding: '0.0rem 0.5rem'
                              }}
                            />
                          </td>
                          <td>
                            <InputText
                              required
                              value={inputOperations.ndc.value(index)}
                              onChange={e => inputOperations.ndc.onChange(index, e.target.value)}
                            />
                          </td>
                          <td>
                            <InputText
                              value={inputOperations.description.value(index)}
                              onChange={e =>
                                inputOperations.description.onChange(index, e.target.value)
                              }
                            />
                          </td>
                          <td>
                            <InputText
                              required
                              type="numeric"
                              value={inputOperations.qtyOfContainersToFill.value(index)}
                              onChange={e =>
                                inputOperations.qtyOfContainersToFill.onChange(
                                  index,
                                  e.target.value
                                )
                              }
                            />
                          </td>
                          <td>
                            <InputText
                              required
                              type="numeric"
                              value={inputOperations.qtyPerContainer.value(index)}
                              onChange={e =>
                                inputOperations.qtyPerContainer.onChange(index, e.target.value)
                              }
                            />
                          </td>
                          <td>
                            <Dropdown
                              value={inputOperations.runType.value(index)}
                              onChange={e => {
                                inputOperations.runType.onChange(index, e.target.value.code);
                              }}
                              options={runTypeOptions}
                              optionLabel="name"
                              placeholder="Select Run Type"
                              style={{
                                width: '9rem',
                                maxWidth: '9rem',
                                padding: '0.0rem 0.5rem'
                              }}
                            />
                          </td>
                          <td>
                            <InputText
                              required
                              type="numeric"
                              value={inputOperations.qtyUnitsToPackage.value(index)}
                              onChange={e =>
                                inputOperations.qtyUnitsToPackage.onChange(index, e.target.value)
                              }
                            />
                          </td>
                          <td>
                            <Calendar
                              dateFormat="mm/dd/yy"
                              className={classes.dateInput}
                              onChange={e =>
                                inputOperations.confirmedDate.onChange(e.target.value, index)
                              }
                              value={inputOperations.confirmedDate.value(index)}
                              style={{
                                width: '8rem',
                                maxWidth: '8rem',
                                margin: 'auto 0.5rem'
                              }}
                            />
                          </td>
                          <td>
                            <InputTextarea
                              value={inputOperations.initialNote.value(index)}
                              onChange={e =>
                                inputOperations.initialNote.onChange(index, e.target.value)
                              }
                              rows={2}
                              cols={20}
                              style={{
                                width: '10rem',
                                maxWidth: '10rem'
                              }}
                            />
                          </td>

                          <td>
                            {index === 0 && (
                              <InputText
                                type="numeric"
                                value={inputOperations.numberOfBottlesAtShiftStart.value(index)}
                                onChange={e =>
                                  inputOperations.numberOfBottlesAtShiftStart.onChange(
                                    index,
                                    e.target.value
                                  )
                                }
                              />
                            )}
                          </td>

                          <td>
                            {index === 0 && (
                              <Calendar
                                showTime
                                hourFormat="12"
                                // minDate={new Date()}
                                value={new Date(inputOperations.jobStartTime.value(index))}
                                onChange={e =>
                                  inputOperations.jobStartTime.onChange(index, e.target.value)
                                }
                              />
                            )}
                          </td>

                          {checkIfThereAreErrors() && (
                            <td>
                              <div className={classes.errorDescription}>
                                {getErrorDescription(index)}
                              </div>
                            </td>
                          )}
                          {checkIfThereAreErrors() && (
                            <td>
                              <img
                                className={classes.deleteIcon}
                                src={DeleteIcon}
                                alt="Delete"
                                onClick={() => handleRowDeleteButtonClick(index)}
                              />
                            </td>
                          )}
                        </tr>
                      );
                    })}
                  </>
                )}
              </tbody>
            </table>
          </div>

          <div className={classes.actionButtonContainer}>
            <Button
              className={classes.verifyButton}
              onClick={handleVerify}
              loading={isBulkUpdating}
              disabled={checkIfVerifyDataButtonIsDiabled()}
            >
              Verify
            </Button>

            <Button
              className={classes.cancelButton}
              onClick={goBack}
              disabled={checkIfVerifyDataButtonIsDiabled()}
            >
              Go Back
            </Button>
          </div>
        </>
      ) : (
        <div className={classes.animationContainer}>
          {bulkUpdateResponse !== 'Success' && (
            <table>
              <thead>
                <tr>
                  <th>Status</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <img
                      src={
                        bulkUpdateResponse?.isfileStructurePpsJobsValidity.invalid
                          ? FailureIcon
                          : SuccessIcon
                      }
                      alt=""
                      style={{ animationDelay: '1s' }}
                    />
                  </td>
                  <td>Validating file structure, Job ID, Priority, Status, Room</td>
                </tr>
                <tr>
                  <td>
                    {bulkUpdateResponse?.isfileStructurePpsJobsValidity.invalid === false && (
                      <img
                        src={
                          bulkUpdateResponse?.isFileDatesOverlapping.invalid
                            ? FailureIcon
                            : SuccessIcon
                        }
                        alt=""
                        style={{ animationDelay: '3s' }}
                      />
                    )}
                  </td>
                  <td>Checking file date ranges and confirmed dates</td>
                </tr>
                <tr>
                  <td>
                    {bulkUpdateResponse?.isfileStructurePpsJobsValidity.invalid === false &&
                      bulkUpdateResponse?.isFileDatesOverlapping.invalid === false && (
                        <img
                          src={
                            bulkUpdateResponse?.isJobIdsUnique.invalid ? FailureIcon : SuccessIcon
                          }
                          alt=""
                          style={{ animationDelay: '5s' }}
                        />
                      )}
                  </td>
                  <td>Validating job IDs are unique</td>
                </tr>
                <tr>
                  <td>
                    {bulkUpdateResponse?.isfileStructurePpsJobsValidity.invalid === false &&
                      bulkUpdateResponse?.isFileDatesOverlapping.invalid === false &&
                      bulkUpdateResponse?.isJobIdsUnique.invalid === false && (
                        <img
                          src={
                            bulkUpdateResponse?.isNDCFormatValid.invalid ? FailureIcon : SuccessIcon
                          }
                          alt=""
                          style={{ animationDelay: '7s' }}
                        />
                      )}
                  </td>
                  <td>Checking NDC format</td>
                </tr>
              </tbody>
            </table>
          )}
          <div className={classes.progressBar}>
            <div
              className={classes.percentageBar}
              style={{ maxWidth: getMaxWidthForProgressBar() }}
            ></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default observer(DataValidationComponent);
